import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import { GlobalVariables } from 'Globals/GlobalVariables'
import City from 'components/City'
import './font.css'
import ImageCollection from 'components/ImageCollection'
import Municipalities from 'components/Municipalities'
import { citycollections_de } from 'Content/CityDatas/citycollections_de'
import { citycollections_fr } from 'Content/CityDatas/citycollections_fr'
import { city_datas_de } from 'Content/CityDatas/city_datas_de'
import { city_datas_fr } from 'Content/CityDatas/city_datas_fr'
import { other_labels_de } from 'Content/CityDatas/other_lables_de'
import { other_labels_fr } from 'Content/CityDatas/other_lables_fr'
import { ColorKey } from 'components/ColorKey'
import { ChartFrame } from 'components/ChartFrame'
import { AnnotatedImage } from 'components/AnnotatedImage'
import { CircleAnnotation2 } from 'components/Annotation/CircleAnnotation2'
import {
  colors_dm,
  getColorKeyEntries,
} from 'Content/CityDatas/sat_images/color_key_entries'
import { useState } from 'react'

const tenant_cities: { [k in TenantKey]: string[] } = {
  '24heures': ['lausanne', 'geneva', 'bern'],
  bazonline: ['basel', 'bern', 'zurich'],
  berneroberlaender: ['bern', 'zurich', 'basel'],
  bernerzeitung: ['bern', 'zurich', 'basel'],
  derbund: ['bern', 'zurich', 'basel'],
  landbote: ['zurich', 'bern', 'basel'],
  langenthalertagblatt: ['bern', 'zurich', 'basel'],
  tagesanzeiger: ['zurich', 'bern', 'basel'],
  tdg: ['geneva', 'lausanne', 'bern'],
  thunertagblatt: ['bern', 'zurich', 'basel'],
  zsz: ['zurich', 'bern', 'basel'],
  zuonline: ['zurich', 'bern', 'basel'],
  bilan: [],
}
var cities_debug = ['zurich', 'bern', 'basel', 'lausanne', 'geneva']
const tenant_gdes = {
  tagesanzeiger: 261,
  tdg: 5724,
  zuonline: 261,
  zsz: 261,
  landbote: 261,
  langenthalertagblatt: 261,
  thunertagblatt: 261,
  bazonline: 2701,
  berneroberlaender: 351,
  bernerzeitung: 351,
  derbund: 351,
  '24heures': 5724,
  bilan: 261,
}

const debug = window.document.title === 'TA-Interaktiv Microfrontend'
const isMobile = window.innerWidth < 712
const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const citycollections =
    tenant.lang === 'de' ? citycollections_de : citycollections_fr
  var part = properties?.part || '0'
  const city_datas = tenant.lang === 'de' ? city_datas_de : city_datas_fr

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  const urlgde = urlParams.get('gemeinde') || urlParams.get('commune')

  const other_labels = tenant.lang === 'de' ? other_labels_de : other_labels_fr
  return (
    <AppContainer $colorMode={colorMode}>
      {(part === '0' || debug) && (
        <TextWidthExtended>
          <ChartFrame
            lang='de'
            colorMode={colorMode}
            source={other_labels.source}
          >
            <ColorKey
              centered
              entries={getColorKeyEntries(colorMode, tenant.lang, true) as any}
            />
            <AnnotatedImage
              img={require('../../Content/Maps/maps_ch' +
                (isMobile ? '_mob' : '') +
                (colorMode == 'dark' ? '_dm' : '') +
                '.jpg')}
              annotations={[
                {
                  content: (
                    <CircleAnnotation2
                      offsetx={isMobile ? 1 : 200}
                      offsety={isMobile ? -70 : 0}
                    >
                      {other_labels.map_labels[0]}
                    </CircleAnnotation2>
                  ),
                  position: { x: 58, y: 28 },
                  position_mobile: { x: 60, y: 42 },
                },
                {
                  content: (
                    <CircleAnnotation2 offsetx={isMobile ? 1 : 0} offsety={100}>
                      {other_labels.map_labels[1]}{' '}
                    </CircleAnnotation2>
                  ),
                  position: { x: 11, y: 67 },
                  position_mobile: { x: 9, y: 63 },
                },
                {
                  content: (
                    <CircleAnnotation2
                      offsetx={0}
                      offsety={isMobile ? 100 : 120}
                    >
                      {other_labels.map_labels[2]}{' '}
                    </CircleAnnotation2>
                  ),
                  position: { x: 79, y: 62 },
                  position_mobile: { x: 80, y: 60 },
                },
                {
                  content: (
                    <CircleAnnotation2
                      offsetx={
                        isMobile
                          ? tenant.lang === 'fr'
                            ? 0
                            : -1
                          : tenant.lang === 'fr'
                          ? -80
                          : -200
                      }
                      offsety={isMobile ? -100 : -40}
                    >
                      {other_labels.map_labels[3]}
                    </CircleAnnotation2>
                  ),
                  position: { x: tenant.lang === 'fr' ? 23 : 41, y: 35 },
                  position_mobile: { x: tenant.lang === 'fr' ? 23 : 45, y: 45 },
                },
              ]
                .filter((f: any) => (isMobile ? f.position_mobile : f.position))
                .map((m: any) => ({
                  content: m.content,
                  position: !m.position_mobile
                    ? m.position
                    : isMobile
                    ? m.position_mobile
                    : m.position,
                }))}
            />
          </ChartFrame>
          <Spacer style={{ height: '60px' }} />
        </TextWidthExtended>
      )}
      {(part === '1' || debug) && (
        <>
          {(debug ? cities_debug : tenant_cities[tenant.key]).map((city,i) => {
            return (
              <City
              key={"city_"+i}
                lang={tenant.lang}
                colorMode={colorMode}
                cityData={city_datas[city]}
                lables={other_labels}
              />
            )
          })}
        </>
      )}
      {(part === '2' || debug) && (
        <>
          <TextWidthExtended>
            <>{!isMobile && <Spacer style={{ height: '15px' }} />}</>
            <ColorKey
              entries={getColorKeyEntries(colorMode, tenant.lang) as any}
            />
            <Spacer />
            <ImageCollection
              lang={tenant.lang}
              colorMode={colorMode}
              labels={other_labels}
              entries={citycollections.poorcenterrichputskirts.images}
            />
          </TextWidthExtended>
        </>
      )}
      {(part === '3' || debug) && (
        <>
          <TextWidthExtended>
            <>{!isMobile && <Spacer style={{ height: '15px' }} />}</>
            <ColorKey
              entries={getColorKeyEntries(colorMode, tenant.lang) as any}
            />
            <Spacer />
            <ImageCollection
              lang={tenant.lang}
              colorMode={colorMode}
              labels={other_labels}
              entries={citycollections.richcentrepoorputskirts.images}
            />
          </TextWidthExtended>
        </>
      )}
      {(part === '4' || debug) && (
        <>
          <TextWidthExtended>
            <>{!isMobile && <Spacer style={{ height: '15px' }} />}</>
            <ColorKey
              entries={getColorKeyEntries(colorMode, tenant.lang) as any}
            />
            <Spacer />
            <ImageCollection
              lang={tenant.lang}
              colorMode={colorMode}
              labels={other_labels}
              entries={citycollections.mosaiccities.images}
            />
          </TextWidthExtended>
        </>
      )}
      {(part === '5' || debug) && (
        <>
          <TextWidthExtended>
            <>{!isMobile && <Spacer style={{ height: '15px' }} />}</>
            <ColorKey
              entries={getColorKeyEntries(colorMode, tenant.lang) as any}
            />
            <Spacer />
            <ImageCollection
              lang={tenant.lang}
              colorMode={colorMode}
              labels={other_labels}
              entries={citycollections.weakvspower.images}
            />
          </TextWidthExtended>
        </>
      )}
      {(part === '6' || debug) && (
        <Municipalities
          lang={tenant.lang}
          colorMode={colorMode}
          startGde={urlgde ? parseInt(urlgde) : undefined}
          tenantGde={tenant_gdes[tenant.key]}
          labels={other_labels}
        />
      )}
    </AppContainer>
  )
}

const Spacer = styled.div`
  display: inline-block;
  width: 100%;
  height: 0;
`

const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  @media screen and (max-width: 1023px) {
    max-width: 832px;
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (max-width: 711px) {
    max-width: 540px;
    margin-left: auto;
    margin-right: auto;
  }
`
export default MainComponent
